// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay--3v58gDhZiw"};